import React, { Component } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import $, { event } from 'jquery';
import draftToHtml from 'draftjs-to-html';
import { ToastContainer, toast } from "react-toastify";
import * as Loader from 'react-loader-spinner';
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu


export default class ContentLibraryForServiceLine extends Component {
    constructor() {
        super();

        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,

            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                if (this.state.type == 'content') {
                    this.deleteContent(this.state.propsId);
                } else {
                    this.deleteFolder(this.state.propsId);
                }
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchContent()
                this.setState({ disabled: false })
            }
        }];

        this.state = {
            selectedOption: "uploadFileContent",
            uploadURLContent: false,
            imgContent: '',
            callFileContentApi: false,
            type: '',
            contentId: '',
            editorState: EditorState.createEmpty(),
            existingContentInfo: {
                documentSections: [],
                subFolderList: [],
                folderTitle: "Home"
            },
            folderId: "00000000-0000-0000-0000-000000000000",
            folderPathName: 'Home',
            showNoData: false,
            addedFolderInfo: [],
            iconFile: '',
            imageContentType: false,
            videoContentType: false,
            audioContentType: false,
            textContentType: true,
            showAddFolderOverLay: false,
            showAddContentOverLay: false,
            editorState: EditorState.createEmpty(),
            documentList: [],
            showLoader: false,
            editedId: -1,
            languageList: [],
            language: '',
            hideDeletePopup: false,
            published: false,
            folderPath: [
                {
                    id: "00000000-0000-0000-0000-000000000000",
                    label: "Home",
                    depth: 0
                }
            ]
        }
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.fileInput = [];
    }
    componentDidMount() {
        var thisController = this;

        setTimeout(() => {
            thisController.fetchContent();
        }, 300);




    }
    startUpdatingFolder = (el, i) => {
        this.state.showAddFolderOverLay = true;
        document.getElementById("labelId").value = el.label;
        document.getElementById("descriptionId").value = el.description;
        // document.getElementById("iconId").value = el.icon;
        this.state.updatingFolder = true;
        this.state.idToBeUpdated = el.id;

        this.setState(this.state);
    }
    startUpdatingSection = (el, i) => {
        this.state.showAddContentOverLay = true;
        this.state.mediaId = el.mediaId;
        this.state.idToBeUpdated = el.id;

        //   htmlToDraft(convertToRaw(this.state.editorState.getCurrentContent())) = el.textContent;
        if (el.type == 'TEXT') {
            document.getElementById('contentTypeId').value = 'TEXT';
            this.state.textContentType = true;
            this.state.imageContentType = false;
            this.state.videoContentType = false;
            this.state.audioContentType = false;

        } else if (el.type == 'IMAGE') {
            document.getElementById('contentTypeId').value = 'IMAGE';
            this.state.textContentType = false;
            this.state.imageContentType = true;
            this.state.videoContentType = false;
            this.state.audioContentType = false;


        } else if (el.type == 'VIDEO') {
            document.getElementById('contentTypeId').value = 'VIDEO';
            this.state.textContentType = false;
            this.state.imageContentType = false;
            this.state.videoContentType = true;
            this.state.audioContentType = false;

        } else if (el.type == 'AUDIO') {
            document.getElementById('contentTypeId').value = 'AUDIO';
            this.state.textContentType = false;
            this.state.imageContentType = false;
            this.state.videoContentType = false;
            this.state.audioContentType = true;

        }
        this.state.updatingContent = true;
        this.state.idToBeUpdated = el.id;
        this.setState(this.state);
    }
    startAddingFolder = () => {
        document.getElementById("labelId").value = "";
        document.getElementById("descriptionId").value = "";
        document.getElementById("iconId").value = "";
        this.state.showAddFolderOverLay = true;
        this.state.updatingFolder = false;
        this.setState(this.state);
    }
    startAddingContent = () => {
        //document.getElementById("contentId").value = "";
        document.getElementById('contentTypeId').value = 'TEXT';
        this.state.textContentType = true;
        this.state.imageContentType = false;
        this.state.videoContentType = false;
        this.state.audioContentType = false;
        this.state.contentType = 'TEXT';
        this.state.updatingContent = false;
        this.state.showAddContentOverLay = true;
        this.setState(this.state);
    }
    previewMode = () => {

        this.state.showpreviewModeOverLay = true;
        this.setState(this.state);
    }


    handleSubmit = (event) => {
        event.preventDefault();
        let element = document.getElementById("uploadFile");
        element.click();
    }

    contentTypeOnChange = (e) => {
        this.state.contentType = e.target.value;
        document.getElementById("imageContentUrl").value = "";
        document.getElementById("videoContentUrl").value = "";
        document.getElementById("audioContentUrl").value = "";
        if (e.target.value == "TEXT") {
            this.state.textContentType = true;
            this.state.imageContentType = false;
            this.state.videoContentType = false;
            this.state.audioContentType = false;

        } else if (e.target.value == "IMAGE") {
            this.state.textContentType = false;
            this.state.imageContentType = true;
            this.state.videoContentType = false;
            this.state.audioContentType = false;

        } else if (e.target.value == "VIDEO") {
            this.state.textContentType = false;
            this.state.imageContentType = false;
            this.state.videoContentType = true;
            this.state.audioContentType = false;

        } else if (e.target.value == "AUDIO") {
            this.state.textContentType = false;
            this.state.imageContentType = false;
            this.state.videoContentType = false;
            this.state.audioContentType = true;
        }
        this.setState(this.state);

    }
    closeAddFolderoverLay = () => {
        this.state.showAddFolderOverLay = false;
        this.setState(this.state);
    }
    closeAddContentOverLay = () => {
        this.state.showAddContentOverLay = false;
        this.setState(this.state);
    }
    closepreviewModeOverLay = () => {
        this.state.showpreviewModeOverLay = false;
        this.setState(this.state);
    }
    fetchFolder() {
        var fetchController = this;
        $.ajax({
            url: '/my-jeeva-api/library-module-admin/content',

            method: 'GET',
            data: {
                scopeGroup: fetchController.props.location.state.serviceLineId,
                scopeGroups: JSON.stringify([fetchController.props.location.state.serviceLineId]),
                scope: "SERVICE_LINE",
                parentFolderId: fetchController.state.folderId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    if (res.result.length == 0) {
                        fetchController.state.showNoData = true;
                        fetchController.state.addedFolderInfo = res.result;
                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.state.showNoData = false;
                        fetchController.state.addedFolderInfo = res.result;
                        fetchController.state.showAddFolderOverLay = false;
                        fetchController.setState(fetchController.state);
                    }
                }
            }
        })
    }
    saveFolder = () => {
        this.state.editedId = "-1";
        this.setState(this.state);
        var saveController = this;
        var label = document.getElementById("labelId").value;
        var description = document.getElementById("descriptionId").value;
        var icon = saveController.state.iconFile;
        var formData = new FormData();
        formData.append("label", label);
        formData.append("description", description);
        formData.append("icon", icon);
        formData.append("parentId", saveController.state.folderId);
        formData.append("libraryModuleId", saveController.state.existingContentInfo.libraryModuleId);
        if (label == "") {
            saveController.notifyEmptyFields();
        } else {
            var timer = setInterval(function () {
                clearTimeout(timer);
                $.ajax({
                    url: "/my-jeeva-api/library-module-admin/folder",

                    method: 'POST',
                    data: formData,
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token")
                    },
                    processData: false,
                    contentType: false,
                    success: function (res) {
                        if (res.success === true) {
                            //   saveController.notifyFolderAdded();
                            saveController.fetchContent();
                        } else {
                            saveController.notifyFailedResponse(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }
                })
            }, 2000);
        }
    }

    notifyEmptyFields() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please add valid data in the fields</b>, {
            position: "top-center"
        });
    }

    updateFolder = (index) => {
        this.setState(this.state);
        var saveController = this;
        var label = document.getElementById("labelId").value;
        var description = document.getElementById("descriptionId").value;
        var icon = saveController.state.iconFile;
        var formData = new FormData();
        formData.append("label", label);
        formData.append("description", description);
        formData.append("icon", icon);
        if (label == "") {
            saveController.notifyEmptyFields();
        } else {
            var timer = setInterval(function () {
                clearTimeout(timer);
                $.ajax({
                    url: "/my-jeeva-api/library-module-admin/folder/" + saveController.state.idToBeUpdated,

                    method: 'PATCH',
                    data: formData,
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token")
                    },
                    processData: false,
                    contentType: false,
                    success: function (res) {
                        if (res.success === true) {
                            // saveController.notifyFolderUpdated();
                            saveController.fetchContent();
                        } else {
                            saveController.notifyFailedResponse(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }
                })
            }, 2000);
        }
    }

    fetchContent(updateFolderPath) {
        var fetchController = this;

        $.ajax({
            url: '/my-jeeva-api/library-module-admin/content',

            method: 'GET',
            data: {
                scopeGroup: fetchController.props.location.state.serviceLineId,
                scopeGroups: JSON.stringify([fetchController.props.location.state.serviceLineId]),
                scope: "SERVICE_LINE",
                parentFolderId: fetchController.state.folderId

            },
            success: function (res) {
                if (res.success == true) {
                    if (res.result.length == 0) {
                        fetchController.state.showNoData = true;
                        fetchController.state.existingContentInfo = res.result;
                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.state.callFileContentApi = false;
                        fetchController.state.showNoData = false;
                        fetchController.state.existingContentInfo = res.result;
                        fetchController.state.showAddContentOverLay = false;
                        fetchController.state.showAddFolderOverLay = false;
                        fetchController.state.showpreviewModeOverLay = false;
                        fetchController.state.published = res.result.published;
                        if (updateFolderPath) {
                            fetchController.state.folderPath.push({
                                id: fetchController.state.folderId,
                                label: res.result.folderTitle,
                                depth: fetchController.state.folderPath.length
                            });
                        }
                        fetchController.setState(fetchController.state);
                    }

                }
            }
        })
    }
    fetchStream(mediaId) {
        var fetchController = this;

        $.ajax({
            url: '/my-jeeva-api/stream',
            
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            data: {
                mediaId: mediaId

            },
            success: function (res) {
                if (res.success == true) {
                    console.log("done with streaming");
                }
            }
        })
    }
    fetchMedia(mediaId) {
        var fetchController = this;

        $.ajax({
            url: '/my-jeeva-api/media',
            
            method: 'GET',

            data: {
                mediaId: mediaId

            },
            success: function (res) {
                fetchController.state.mediaUrl = res;
                fetchController.setState(fetchController.state);
            }
        })
    }

    saveContent = () => {
        this.state.editedId = "-1";
        this.setState(this.state);
        var saveController = this;

        var contentData;
        var textContent = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));

        var videoPattern = new RegExp(/(http(s?):)\/\/[A-Z0-9a-z\.\/_\-]*(\.mp4)/);
        var audioPattern = new RegExp(/(http(s?):)\/\/[A-Z0-9a-z\.\/_\-]*(\.mp3)/);
        var imagePattern = new RegExp(/(http(s?):)\/\/[A-Z0-9a-z\.\/_\-]*\.(jpg|jpeg|gif|png)/);

        var mediaUrl;
        var imageContentUrl = document.getElementById('imageContentUrl').value;
        var videoContentUrl = document.getElementById('videoContentUrl').value;
        var audioContentUrl = document.getElementById('audioContentUrl').value;
        if (imageContentUrl != "") {
            if (imagePattern.test(imageContentUrl)) {
                mediaUrl = document.getElementById('imageContentUrl').value;
            }
            else {
                saveController.notifyImproperField();
            }
        } else if (videoContentUrl != "") {
            if (videoPattern.test(videoContentUrl)) {
                mediaUrl = document.getElementById('videoContentUrl').value;
            }
            else {
                saveController.notifyImproperField();
            }
        } else if (audioContentUrl != "") {
            if (audioPattern.test(audioContentUrl)) {
                mediaUrl = document.getElementById('audioContentUrl').value;
            }
            else {
                saveController.notifyImproperField();
            }
        } else {
            var caption;
            var imgCaption = document.getElementById('imageUrlCaptionId').value;
            var videoCaption = document.getElementById('videoUrlCaptionId').value;
            var audioCaption = document.getElementById('audioUrlCaptionId').value;
            if (imgCaption != "") {
                caption = imgCaption
            } else if (videoCaption != "") {
                caption = videoCaption
            } else if (audioCaption != "") {
                caption = audioCaption
            }

            if (saveController.state.contentType == 'TEXT') {
                if (textContent == "" || textContent.startsWith('<p></p>')) {
                    saveController.notifyEmptyFields();
                } else {
                    contentData = {
                        type: saveController.state.contentType,
                        textContent: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())),
                        folderId: saveController.state.folderId
                    }
                }
            } else {
                if (mediaUrl == "" || caption == "") {
                    saveController.notifyEmptyFields();
                } else {
                    contentData = {
                        type: saveController.state.contentType,
                        mediaUrl: mediaUrl,
                        caption: caption,
                        folderId: saveController.state.folderId
                    }
                }
            }
        }

        $.ajax({
            url: "/my-jeeva-api/library-module-admin/section?libraryModuleId=" + saveController.state.existingContentInfo.libraryModuleId + "&folderId=" + saveController.state.folderId,

            method: 'POST',
            data: JSON.stringify(contentData),
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json"
            },
            success: function (res) {
                if (res.success === true) {
                    // saveController.notifyContentAdded();
                    saveController.fetchContent();
                } else {
                    saveController.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        })
    }


    notifyImproperField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Please enter a valid data</b>, {
            position: "top-center",
        });
    }

    updateTextContent = (event) => {
        this.state.editedId = "-1";
        this.setState(this.state);
        var updateController = this;

        var contentData = {
            id: updateController.state.idToBeUpdated,
            textContent: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())),

        }

        $.ajax({
            url: "/my-jeeva-api/section",
            
            method: 'PATCH',
            data: JSON.stringify(contentData),
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': "application/json"
            },

            success: function (res) {
                if (res.success === true) {
                    // updateController.notifyContentUpdated();
                    updateController.fetchContent();
                } else {
                    updateController.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "";
                }
            }
        })
    }
    onEditorStateChange = (editorState) => {
        const contentState = editorState.getCurrentContent();
        const oldContent = this.state.editorState.getCurrentContent();
        if (contentState.getPlainText().length > 1000) {
            const editorState = EditorState.moveFocusToEnd(
                EditorState.push(
                    this.state.editorState,
                    ContentState.createFromText(oldContent.getPlainText())
                )
            );
            this.state.editorState = editorState;
        } else {
            this.state.docCharacterCount = contentState.getPlainText().length;
            this.state.editorState = editorState;
        }
        this.setState(this.state);
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }
    notifyFolderAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Folder added successfully</b>, {
            position: "top-center",
        });
    }
    notifyFolderUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Folder updated successfully</b>, {
            position: "top-center",
        });
    }
    notifyContentUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Content updated successfully</b>, {
            position: "top-center",
        });
    }
    notifyContentAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Content added successfully</b>, {
            position: "top-center",
        });
    }
    onChangeIconFile = (event) => {
        this.state.iconFile = event.target.files[0];
        this.setState(this.state);
    }
    onFileContentChange = (event) => {
        this.state.fileContent = event.target.files[0];
        this.state.callFileContentApi = true;
        this.setState(this.state);
    }

    onFileContentUploadApi = (event) => {
        this.state.editedId = "-1";
        this.setState(this.state);
        var saveController = this;
        var caption;
        var imgCaption = document.getElementById('imageCaptionId').value;
        var videoCaption = document.getElementById('videoCaptionId').value;
        var audioCaption = document.getElementById('audioCaptionId').value;
        if (imgCaption != "") {
            caption = imgCaption
        } else if (videoCaption != "") {
            caption = videoCaption
        } else if (audioCaption != "") {
            caption = audioCaption
        }

        var formData = new FormData();
        formData.append("mediaContent", saveController.state.fileContent);
        formData.append("folderId", saveController.state.folderId);
        formData.append("type", saveController.state.contentType);
        formData.append("contentId", saveController.state.existingContentInfo.contentId);
        formData.append("caption", caption);
        if (caption == "" || imgCaption == "" || videoCaption == "" || audioCaption == "") {
            saveController.notifyEmptyFields();
        } else {
            var timer = setInterval(function () {
                clearTimeout(timer);
                $.ajax({
                    url: "/my-jeeva-api/upload-content",
                    
                    method: 'POST',
                    data: formData,
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token")
                    },
                    processData: false,
                    contentType: false,
                    success: function (res) {
                        if (res.success === true) {
                            var mediaId = res.result;
                            // saveController.notifyContentAdded();
                            saveController.fetchContent(mediaId);
                        } else {
                            saveController.notifyFailedResponse(res.result);
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }
                })
            }, 2000);
        }
    }
    updateMediaContent = () => {
        this.state.editedId = "-1";
        this.setState(this.state);
        var updateController = this;
        var formData = new FormData();
        formData.append("id", updateController.state.idToBeUpdated);
        formData.append("mediaId", updateController.state.mediaId);
        formData.append("type", updateController.state.contentType);
        formData.append("mediaContent", updateController.state.fileContent);
        var timer = setInterval(function () {
            clearTimeout(timer);
            $.ajax({
                url: "/my-jeeva-api/update-media-content",
                
                method: 'PATCH',
                data: formData,
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),

                },
                processData: false,
                contentType: false,

                success: function (res) {
                    if (res.success === true) {
                        // updateController.notifyContentUpdated();
                        updateController.fetchContent();
                    } else {
                        updateController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            })
        })
    }
    handleMouseEnterDoc = (id) => {
        this.state.hoverId = id;
        this.setState(this.state);
    }
    handleMouseLeaveDoc = () => {
        this.state.hoverId = -1;
        this.setState(this.state);
    }
    makeCelleditSubFolder(index) {
        this.markAsBeingEdited(this.state.existingContentInfo.subFolderList[index].id);
    }
    makeCelleditSection(index) {
        this.markAsBeingEdited(this.state.existingContentInfo.documentSections[index].id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }
    onFolderClick(id) {
        this.state.folderId = id;
        this.setState(this.state);
        this.fetchContent(true);
    }
    onFolderNameClicked(id, depth) {
        var newPath = [];
        var folder;
        for (var i = 0; i < this.state.folderPath.length; i++) {
            folder = this.state.folderPath[i];
            if (folder.depth < depth) {
                newPath.push(folder);
            }
        }
        this.state.folderPath = newPath;
        this.onFolderClick(id);
    }
    deleteFolder = (id) => {
        let deleteRowViewController = this.state.existingContentInfo.subFolderList;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/library-module-admin/folder/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {
                        deleteApiViewController.state.surveyId = id;
                        deleteApiViewController.setState(deleteApiViewController.state);
                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        //  deleteConstructorVariables.notifyDelete();
                        ;
                        deleteRowViewController.splice(id, 1);
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.existingContentInfo.subFolderList.splice(id, 1);
        }
        deleteConstructorVariables.fetchContent();


    }
    deleteContent = (id) => {
        let deleteRowViewController = this.state.existingContentInfo.documentSections;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/library-module-admin/section/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {
                        deleteApiViewController.state.surveyId = id;
                        deleteApiViewController.setState(deleteApiViewController.state);
                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDeleteContent();

                        deleteRowViewController.splice(id, 1);
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.existingContentInfo.subFolderList.splice(id, 1);
        }
        deleteConstructorVariables.fetchContent();


    }
    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Folder deleted successfully</b>, {
            position: "top-center",
        });
    }
    notifyError() {
        toast.dismiss();
        toast(
          <b>
            <img
              src="assets/images/warn.svg"
              style={{ paddingRight: "0px", height: "20px", width: "20px" }}
              content=""
            />
            &nbsp;&nbsp;Oops! Error occurred.Please try again
          </b>,
          {
            position: "top-center",
          }
        );
      }
    notifyDeleteContent() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Content deleted successfully</b>, {
            position: "top-center",
        });
    }

    sectionTemplate(section) {
        switch (section.type) {
            case 'TEXT': return (


                <div className='col-sm-9'>

                    <div className="textarea"
                        style={{
                            marginTop: '1vw', marginBottom: '1vw', marginLeft: '1vw',
                            borderRadius: '10px',
                            padding: '6px', height: 'auto',
                            backgroundColor: "#EBF5FF", maxWidth: '50vw'
                        }} dangerouslySetInnerHTML={{ __html: section.textContent }}></div>
                </div>
            )
            case 'IMAGE':
                var mediaUrl;
                if (section.mediaUrl != null) {
                    mediaUrl = section.mediaUrl;
                } else if (section.mediaId != null) {
                    mediaUrl = "/my-jeeva-api/media/" + section.mediaId;
                } else {
                    mediaUrl = "/assets/images/not-available.jpg";
                }
                return (
                    // <div>
                    //     <div className='col-sm-2'>
                    //         <label style={{ marginLeft: '1vw', marginTop: '1vw' }}>{section.caption}</label>
                    //     </div>
                    <div className='col-sm-9'>
                        <div className="sectionImage" id={"sectionImage" + section.id}
                            style={{
                                borderRadius: '10px', margin: '10px',
                                padding: '6px', height: 'auto',
                                textAlign: 'center'
                            }}><img src={mediaUrl} style={{ maxWidth: '50vw', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}></img></div>

                    </div>
                    // </div>
                );
            case 'VIDEO':
                var mediaUrl;
                if (section.mediaUrl != null) {
                    mediaUrl = section.mediaUrl;
                } else if (section.mediaId != null) {
                    mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
                } else {
                    mediaUrl = "/assets/images/not-available.jpg";
                }
                return (
                    // <div>
                    //     <div className='col-sm-2'>
                    //         <label style={{ marginLeft: '1vw', marginTop: '1vw' }}>{section.caption}</label>
                    //     </div>
                    <div className='col-sm-9'>
                        <div className="sectionVideo" id={"sectionVideo" + section.id}
                            style={{
                                borderRadius: '10px', margin: '10px',
                                padding: '6px', height: 'auto',
                                textAlign: 'center'
                            }}>
                            <video width="650" height="400" controls >
                                <source src={mediaUrl} type="video/mp4" style={{
                                    maxWidth: '50vw', textDecoration: 'underline',
                                    color: 'blue', cursor: 'pointer'
                                }} />
                            </video>
                        </div>
                    </div>

                    // </div>
                );
            case 'AUDIO':
                var mediaUrl;
                if (section.mediaUrl != null) {
                    mediaUrl = section.mediaUrl;
                } else if (section.mediaId != null) {
                    mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
                } else {
                    mediaUrl = "/assets/images/not-available.jpg";
                }
                return (
                    // <div>
                    //     <div className='col-sm-2'>
                    //         <label style={{ marginLeft: '1vw', marginTop: '1vw' }}>{section.caption}</label>
                    //     </div>

                    <div className='col-sm-9'>
                        <div className="sectionAudio" id={"sectionAudio" + section.id}
                            style={{
                                borderRadius: '10px', margin: '10px',
                                padding: '6px', height: 'auto',
                                textAlign: 'center'
                            }}>
                            <audio controlsList="nodownload" controls style={{ width: '50vw' }}>
                                <source src={mediaUrl} type="audio/mpeg" style={{ maxWidth: '50vw', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} />
                            </audio>
                            {/* <audio src={mediaUrl} ></audio> */}
                        </div>
                    </div>
                    // </div>
                );
        }
    }
    changeContent = () => {
        this.state.callFileContentApi = false;
        this.setState(this.state);
    }
    onChangeRadioButton = (event) => {
        if (event.target.value == "uploadURLContent") {
            this.state.selectedOption = "uploadURLContent";
            this.state.uploadURLContent = true;
        } else {
            this.state.selectedOption = "uploadFileContent";
            this.state.uploadURLContent = false;
        }
        this.setState(this.state);
    }

    unPublish = () => {
        var unPublishController = this;
        $.ajax({
            url: '/my-jeeva-api/unpublish',
            
            method: 'GET',
            data: {
                scopeGroup: this.props.location.state.serviceLineId,
                scope: "SERVICE_LINE"
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    unPublishController.notifySuccess("Unpublished this version");
                    unPublishController.fetchContent();
                }
            }
        })
    }

    notifySuccess(msg) {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{msg}</b>, {
            position: "top-center",
        });
    }

    publish = () => {
        var publishController = this;
        $.ajax({
            url: '/my-jeeva-api/publish',
            
            method: 'GET',
            data: {
                scopeGroup: this.props.location.state.serviceLineId,
                scope: "SERVICE_LINE"
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    publishController.notifySuccess("Published this version");
                    publishController.fetchContent();
                }
            }
        })
    }

    openDeletePopUp = (id) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: 'Are you sure to delete this? ',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteFolder(id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    openDeletePopUp = (id) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: 'Are you sure to delete this? ',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteContent(id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    render() {
        const { editorState } = this.state;
        return (
            <div id='contentLibForServiceLineTab'>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.showLoader}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }} />


                <div style={{ display: !this.state.showLoader ? 'block' : 'none' }}>
                    <link rel="stylesheet" href="assets/css/modal-style.css" />

                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <ToastContainer className="Toast-at-center" />

                    <div className="content-header">
                        <div className='row'>
                            <div className='col-sm-6'>
                                <h6 className="nav-item" style={{
                                    color: '#282a65', marginTop: '1vh',
                                    marginLeft: '1vw'
                                }}>Manage Content of {this.state.existingContentInfo.folderTitle}</h6></div>
                            <div className='col-sm-6' align="right" style={{ paddingRight: '14px' }}>
                                <div style={{ display: 'inline-flex' }}>

                                    <h6 className="nav-item" style={{
                                        color: '#282a65', marginTop: '1vh'
                                    }}>Publish : </h6>&nbsp;&nbsp;
                                    <label className="switch">
                                        <input type="checkbox"
                                            id="isPublished"
                                            checked={this.state.published}
                                            // disabled={true}
                                            onClick={this.state.published ? this.unPublish : this.publish}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                    {/* {this.state.hideDeletePopup && (
                                        <DialogComponent target='#contentLibForServiceLineTab'
                                            width='400px'
                                            animationSettings={this.settings}
                                            header='Publish Confirmation'
                                            showCloseIcon={true}
                                            buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={true}
                                            close={this.dialogClose}
                                        >
                                            <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;&nbsp;&nbsp;
                                            Do you want to publish this?<br />
                                            Note: Press 'Yes' to publish or press 'No' to decline.
                                        </DialogComponent>
                                    )} */}

                                </div>
                            </div>
                        </div>

                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-12">

                                    <div className="card-body p-0 mb-25">
                                        <div className="tab-content col-12 p-0">
                                            <div className="tab-pane active show" id="tab_1">
                                                <div className="card card-primary mt-3">
                                                    <div className="card-body raise-form">
                                                        <div className='row'>
                                                            <div className="col-sm-12" align='center'
                                                                style={{
                                                                    display: this.state.showNoData ? 'block' : 'none',
                                                                    marginTop: '10%'
                                                                }}>
                                                                <div style={{

                                                                    width: '40%',
                                                                    fontSize: '22px',
                                                                    color: '#282a65',
                                                                    marginTop: '-50px'
                                                                }}><h3 className="m-0 page-title" style={{ textAlign: 'center' }}>No content added yet!</h3><br />
                                                                    <label>It seems there is no content added.</label><br />
                                                                    <label>Please use below button to add content.</label>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <h2 className="page-title" style={{ marginLeft: '1em', marginBottom: '1em', paddingTop: '0px' }}>
                                                                    <img src="assets/images/folder.png"
                                                                        style={{ paddingRight: '0px', height: '30px', width: '30px' }} content="" /> {
                                                                        this.state.folderPath.map((el, i) => (
                                                                            <a style={{ cursor: 'pointer' }} onClick={() => this.onFolderNameClicked(el.id, el.depth)}>{" / " + el.label}</a>
                                                                        ))
                                                                    }

                                                                </h2>
                                                            </div>
                                                            <div style={{ width: '100%' }}>
                                                                {this.state.existingContentInfo.documentSections.map((section, i) => (

                                                                    <div key={i}>
                                                                        <div className='fontpreviewBox' style={{ borderRadius: '1vw', marginTop: '1vw', boxShadow: '0 0 5px 0 #c2c4d2' }}>
                                                                            <div className={section.caption != null ? 'row' : ''}>
                                                                                <label style={{ display: section.caption != null ? 'block' : 'none', color: 'rgb(40, 42, 101)', marginTop: '1vw', marginLeft: '2vw', fontWeight: '430', fontSize: '18px' }}>{section.caption}</label>
                                                                            </div>
                                                                            <div className='row'>

                                                                                {this.sectionTemplate(section)}
                                                                                <div className='col-sm-3' align="right" style={{ marginLeft: '-1vw' }}>
                                                                                    <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '0.5vw', marginLeft: '-6px' }} >
                                                                                        <img className="img-responsive"
                                                                                            title={(section.id == "") ||
                                                                                                (section.id == this.state.editedId) ? 'Save' : 'Edit'}
                                                                                            style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                                                                            src={(section.id == "") ? this.saveImageSrc : ((section.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                                                                            onClick={() => this.startUpdatingSection(section, i)} />
                                                                                    </button>
                                                                                    <button style={{
                                                                                        backgroundColor: "#ffffff", border: "none", marginTop: '0.5vw', marginLeft: '-6px'
                                                                                    }} title="Delete">
                                                                                        <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                                                                            style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                                                                            onClick={() => (section.id) === "" ?
                                                                                                this.fetchContent() :
                                                                                                this.openDeletePopUp(section.id)}
                                                                                                // this.setState({
                                                                                                //     type: 'content',
                                                                                                //     hideDeletePopup: true, deletePropIndex: i, propsId: section.id
                                                                                                // })} 
                                                                                                /></button>

                                                                                </div>



                                                                            </div>
                                                                        </div>
                                                                    </div>))}

                                                                {this.state.existingContentInfo.subFolderList.map((el, i) => (
                                                                    <div key={i}>
                                                                        <div>
                                                                            <div>

                                                                                <div className='row' style={{ padding: '1vw', borderRadius: '1vw', boxShadow: '0 0 5px 0 #c2c4d2', marginLeft: '0.8vw', marginTop: '1vw', marginRight: '-0.2vw' }}>

                                                                                    <div className='col-sm-1' onClick={() => this.onFolderClick(this.state.existingContentInfo.subFolderList[i].id)}>
                                                                                        <div className='previewText image-container' >
                                                                                            <img id="qr_code" src={"data:png;base64," + this.state.existingContentInfo.subFolderList[i].icon}
                                                                                                style={{
                                                                                                    width: '9vw', marginLeft: '-1vw',
                                                                                                    height: '8vw', borderRadius: '1vw',
                                                                                                    cursor: 'pointer'
                                                                                                }} />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className='col-sm-8' style={{ paddingLeft: '3vw' }}>
                                                                                        <h3 className="m-0 page-title" style={{

                                                                                            paddingBottom: '1vw', paddingTop: '1vw',
                                                                                            border: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                                                                            borderRadius: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '6px' : 'none'
                                                                                        }}>{this.state.existingContentInfo.subFolderList[i].label}</h3>

                                                                                        <div className="textarea"
                                                                                            // disabled={!this.state.user_editable}
                                                                                            style={{
                                                                                                textAlign: 'left',
                                                                                                height: "2.7em", resize: 'none', paddingTop: '6px',
                                                                                                marginTop: '1vw',

                                                                                                border: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                                                                                borderRadius: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '6px' : 'none'
                                                                                            }}
                                                                                            id={"descriptionId" + [i]}
                                                                                            contentEditable={!((this.state.existingContentInfo.subFolderList[i].id == "") ? false :
                                                                                                this.state.existingContentInfo.subFolderList[i].id != this.state.editedId) ? "plaintext-only" : false}
                                                                                        >{this.state.existingContentInfo.subFolderList[i].description}</div>
                                                                                    </div>
                                                                                    <div className='col-sm-3' align="right">
                                                                                        <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '0.5vw', marginLeft: '-6px' }} >
                                                                                            <img className="img-responsive"
                                                                                                title={(this.state.existingContentInfo.subFolderList[i].id == "") ||
                                                                                                    (this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? 'Save' : 'Edit'}
                                                                                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                                                                                src={(this.state.existingContentInfo.subFolderList[i].id == "") ? this.saveImageSrc : ((this.state.existingContentInfo.subFolderList[i].id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                                                                                onClick={(e) => {
                                                                                                    this.startUpdatingFolder(el, i)
                                                                                                }} />
                                                                                        </button>
                                                                                        <button style={{
                                                                                            backgroundColor: "#ffffff", border: "none", marginTop: '0.5vw', marginLeft: '-6px'
                                                                                        }} title="Delete">
                                                                                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                                                                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                                                                                onClick={() => (this.state.existingContentInfo.subFolderList[i].id) === "" ?
                                                                                                    this.fetchContent() :
                                                                                                    this.openDeletePopUp(this.state.existingContentInfo.subFolderList[i].id)}
                                                                                                    // this.setState({
                                                                                                    //     type: 'folder',
                                                                                                    //     hideDeletePopup: true, deletePropIndex: i, propsId: this.state.existingContentInfo.subFolderList[i].id
                                                                                                    // })} 
                                                                                                    /></button>

                                                                                    </div><br />
                                                                                    <br />
                                                                                </div>
                                                                                <br />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                ))}

                                                            </div>
                                                        </div>

                                                        <div className='row'>
                                                            <div className='col-sm-4'></div>
                                                            <div className='col-sm-4'>

                                                            </div>
                                                            <div className='col-sm-4' Align="right" style={{ paddingRight: '2vw' }}>
                                                                <button className="btn action-button"
                                                                    style={{ marginRight: '0.5vw', width: '7.5vw' }} onClick={() => this.startAddingFolder()}>
                                                                    Add Folder </button>
                                                                <button className="btn action-button"
                                                                    onClick={this.startAddingContent}>
                                                                    Add Content </button>
                                                                <button className="btn action-button"
                                                                    onClick={this.previewMode}>
                                                                    Preview </button>
                                                            </div>
                                                        </div>
                                                        {/* ------------- ADD FOLDER -----------               */}
                                                        <div className="modal" style={{ display: this.state.showAddFolderOverLay ? 'block' : 'none' }}>
                                                            <div className="modal-dialog" id="center-aligned-account-modal" >
                                                                <div className="modal-content" style={{
                                                                    position: 'absolute', transform: 'translate(7%, -7%)',
                                                                    height: 'auto', width: '60vw', marginTop: '15vh'

                                                                }} Align="center">
                                                                    <div className="modal-header noBorder">
                                                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => this.closeAddFolderoverLay()}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                                                <path d="M0 0h24v24H0z" fill="none" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <form >
                                                                            <div className='row' >
                                                                                <div className='col-sm-5'></div>
                                                                                <div className='col-sm-2' style={{ marginBottom: '2vw' }} Align="center">
                                                                                    <h1 className="m-0 page-title">{this.state.updatingFolder ? "Update Folder" : "Add Folder"}</h1>
                                                                                </div>
                                                                                <div className='col-sm-5'></div>
                                                                            </div>
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" Align="left" style={{ paddingLeft: '40px' }}>Folder Name</label>
                                                                                <div className="col-sm-8">
                                                                                    <input type="text" name="childName" style={{ borderWidth: "1px" }}
                                                                                        className="form-control-plaintext" id="labelId"
                                                                                    // onChange={this.handleChangeForInputData}
                                                                                    // onBlur={this.validateNameOfDomain}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                {/* <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.name} </span> */}
                                                                            </div> <br />
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" Align="left" style={{ paddingLeft: '40px' }}>Folder Description</label>
                                                                                <div className="col-sm-8">
                                                                                    <textarea type="text" name="childDescription" id="descriptionId" className="form-control"
                                                                                        style={{ borderColor: "rgba(192,192,192,0.3)", borderWidth: "1px" }}
                                                                                    // onBlur={this.validateDescOfDomain} 
                                                                                    // onChange={this.handleChangeForInputData}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                {/* <span className="errorMsg" style={{ color: 'red' }}>{this.state.errors.description} </span> */}
                                                                            </div> <br />
                                                                            <div className="form-group row">
                                                                                <label className="col-sm-3 col-form-label" Align="left" style={{ paddingLeft: '40px' }}>Upload Icon</label>
                                                                                <div className="col-sm-4" Align="left">
                                                                                    <input id="iconId" type="file"
                                                                                        name="bot-icon-input"
                                                                                        accept="image/x-png,image/gif,image/jpeg"
                                                                                        // disabled={!this.state.editable}
                                                                                        onChange={this.onChangeIconFile}
                                                                                    />
                                                                                    {/* <input id="iconId"
                                                                                        type="file"
                                                                                        ref={this.fileInput}
                                                                                        onChange={this.readFile}
                                                                                        style={{ display: "none" }} />
                                                                                    <button onClick={(e) => this.handleSubmit(e)}
                                                                                        style={{
                                                                                            width: "10rem",
                                                                                            height: "3rem",
                                                                                            fontSize: "1rem",
                                                                                            color: "white",
                                                                                            backgroundColor: "#282a65",
                                                                                            borderRadius: '10px',
                                                                                            border: 'none'
                                                                                        }}>
                                                                                        Choose Icon
                                                                                    </button> */}
                                                                                </div>
                                                                                <div className='col-sm-4' align="right">
                                                                                    <button type="button" style={{ fontSize: '1rem' }}
                                                                                        className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal"
                                                                                        onClick={() => this.state.updatingFolder ? this.updateFolder() : this.saveFolder()}>
                                                                                        Done</button>
                                                                                </div>
                                                                            </div>

                                                                            <div className="modal-footer noBorder">

                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* ------------- ADD CONTENT -----------               */}
                                                        <div className="modal" style={{ display: this.state.showAddContentOverLay ? 'block' : 'none' }}>
                                                            <div className="modal-dialog" id="center-aligned-account-modal" >
                                                                <div className="modal-content" style={{
                                                                    position: 'absolute', transform: 'translate(7%, -7%)',
                                                                    height: 'auto', width: '60vw', marginTop: '15vh'

                                                                }} Align="center">
                                                                    <div className="modal-header noBorder">
                                                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => this.closeAddContentOverLay()}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                                                <path d="M0 0h24v24H0z" fill="none" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div className="modal-body">
                                                                        <form ref={(el) => this.childFormRef = el}>
                                                                            <div className='row'>
                                                                                <div className='col-sm-4' style={{ marginTop: '1vw' }}>
                                                                                    <h1 className="m-0 page-title">Add Content</h1></div>
                                                                                <div className='col-sm-8' align="right" style={{ color: 'black' }}>
                                                                                    <label>Select Content Type</label>
                                                                                    <select
                                                                                        id="contentTypeId"
                                                                                        onChange={this.contentTypeOnChange}
                                                                                        style={{
                                                                                            marginTop: '2vw', marginBottom: '2vw',
                                                                                            height: '30px', borderRadius: '4px',
                                                                                            backgroundColor: '#F9F9FB', width: '13vw', marginLeft: '10px'
                                                                                        }}>
                                                                                        <option value='TEXT'>Text</option>
                                                                                        <option value='IMAGE'>Image</option>
                                                                                        <option value='VIDEO'>Video</option>
                                                                                        <option value='AUDIO'>Audio</option>

                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <div className='row'>
                                                                                <div className="form-group row" style={{ display: this.state.textContentType ? 'block' : 'none' }}>
                                                                                    <Editor
                                                                                        id="contentId"
                                                                                        editorState={editorState}
                                                                                        // toolbarClassName="toolbarClassName"
                                                                                        wrapperClassName="demo-wrapper"
                                                                                        editorClassName="demo-editor"
                                                                                        onEditorStateChange={this.onEditorStateChange}
                                                                                        editorStyle={{
                                                                                            marginTop: '1vw',
                                                                                            minHeight: '190px',
                                                                                            border: "1px solid #0094c8",
                                                                                            padding: '6px',
                                                                                            borderRadius: '5px'
                                                                                        }}
                                                                                    />
                                                                                    <div className='row'>
                                                                                        <div className='col-sm-8'></div>
                                                                                        <div className='col-sm-4' align="right">
                                                                                            <button type="button" style={{ fontSize: '1rem' }}
                                                                                                className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal"
                                                                                                onClick={() =>
                                                                                                    // this.state.updatingContent ? (this.state.textContentType ? this.updateTextContent() :
                                                                                                    //     this.updateMediaContent()) :
                                                                                                    this.saveContent()}>
                                                                                                Done</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="form-group row" style={{ width: '100%', display: this.state.imageContentType ? 'block' : 'none' }}>
                                                                                    <div className='row'>
                                                                                        <div className='col-sm-1'></div>
                                                                                        <div className='col-sm-3' Align="left">
                                                                                            <label style={{ color: 'black' }}>
                                                                                                <input style={{ marginRight: '1vw' }}
                                                                                                    type="radio"
                                                                                                    value="uploadFileContent"
                                                                                                    checked={this.state.selectedOption === "uploadFileContent"}
                                                                                                    onChange={(event) => this.onChangeRadioButton(event)}
                                                                                                />Upload Image File</label>
                                                                                        </div>
                                                                                        <div className='col-sm-3' Align="left">
                                                                                            <label style={{ color: 'black' }}>
                                                                                                <input style={{ marginRight: '1vw' }}
                                                                                                    type="radio"
                                                                                                    value="uploadURLContent"
                                                                                                    checked={this.state.selectedOption === "uploadURLContent"}
                                                                                                    onChange={(event) => this.onChangeRadioButton(event)}
                                                                                                />Enter Image URL</label></div>
                                                                                        <div className='col-sm-4'></div>


                                                                                    </div>
                                                                                    <div style={{ marginTop: '3vw', display: this.state.uploadURLContent ? 'none' : 'block' }}>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Caption</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="imageCaptionId" />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row' style={{ marginTop: '2vw' }}>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Upload Image</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4' Align="left">
                                                                                                <input id="imageContentId" type="file"
                                                                                                    name="bot-icon-input"
                                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                                    // disabled={!this.state.editable}
                                                                                                    onChange={(event) => this.onFileContentChange(event)}
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-8'></div>
                                                                                            <div className='col-sm-4' align="right">
                                                                                                <button type="button" style={{ marginTop: '3vw', fontSize: '1rem' }}
                                                                                                    className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal"

                                                                                                    onClick={(event) => this.state.updatingContent ?
                                                                                                        this.updateMediaContent(event) :
                                                                                                        this.onFileContentUploadApi(event)}>
                                                                                                    Done</button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className='row' style={{ marginTop: '3vw', display: this.state.uploadURLContent ? 'block' : 'none' }}>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Caption</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="imageUrlCaptionId" />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row' style={{ marginTop: '3vw' }}>
                                                                                            <div className='col-sm-2'></div>
                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Enter Image URL</label>
                                                                                            </div>
                                                                                            <div className='col-sm-4' Align="left">
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="imageContentUrl"
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div></div>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-8'></div>
                                                                                            <div className='col-sm-4' align="right">
                                                                                                <button type="button" style={{ marginTop: '3vw', fontSize: '1rem' }}
                                                                                                    className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal"

                                                                                                    onClick={(event) => this.state.updatingContent ?
                                                                                                        this.updateMediaContent(event) :
                                                                                                        this.saveContent(event)}>
                                                                                                    Done</button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>
                                                                                <div className="form-group row" style={{ width: '100%', display: this.state.videoContentType ? 'block' : 'none' }}>
                                                                                    <div className='row'>
                                                                                        <div className='col-sm-1'></div>
                                                                                        <div className='col-sm-3' Align="left">
                                                                                            <label style={{ color: 'black' }}>
                                                                                                <input style={{ marginRight: '1vw' }}
                                                                                                    type="radio"
                                                                                                    value="uploadFileContent"
                                                                                                    checked={this.state.selectedOption === "uploadFileContent"}
                                                                                                    onChange={(event) => this.onChangeRadioButton(event)}
                                                                                                />Upload Video File</label>
                                                                                        </div>
                                                                                        <div className='col-sm-3' Align="left">
                                                                                            <label style={{ color: 'black' }}>
                                                                                                <input style={{ marginRight: '1vw' }}
                                                                                                    type="radio" Align="left"
                                                                                                    value="uploadURLContent"
                                                                                                    checked={this.state.selectedOption === "uploadURLContent"}
                                                                                                    onChange={(event) => this.onChangeRadioButton(event)}
                                                                                                />Enter Video URL</label></div>
                                                                                        <div className='col-sm-4'></div>


                                                                                    </div>
                                                                                    <div className='row' style={{ marginTop: '3vw', display: this.state.uploadURLContent ? 'none' : 'block' }}>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Caption</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="videoCaptionId" />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row' style={{ marginTop: '2vw' }}>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Upload Video</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4' Align="left">
                                                                                                <input id="videoContentId" type="file"
                                                                                                    name="bot-icon-input"
                                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                                    // disabled={!this.state.editable}
                                                                                                    onChange={(event) => this.onFileContentChange(event)}
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div></div>

                                                                                    </div>
                                                                                    <div className='row' style={{ marginTop: '3vw', display: this.state.uploadURLContent ? 'block' : 'none' }}>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Caption</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="videoUrlCaptionId" />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row' style={{ marginTop: '3vw' }}>
                                                                                            <div className='col-sm-2'></div>
                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Enter Video URL</label>
                                                                                            </div>
                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="videoContentUrl"
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div></div>

                                                                                    </div>

                                                                                    <div className='row'>
                                                                                        <div className='col-sm-8'></div>
                                                                                        <div className='col-sm-4' align="right">
                                                                                            <button type="button" style={{ marginTop: '3vw', fontSize: '1rem' }}
                                                                                                className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal"
                                                                                                onClick={(event) => this.state.callFileContentApi ? this.onFileContentUploadApi(event) : this.saveContent(event)}>
                                                                                                Done</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="form-group row" style={{ width: '100%', display: this.state.audioContentType ? 'block' : 'none' }}>
                                                                                    <div className='row'>
                                                                                        <div className='col-sm-1'></div>
                                                                                        <div className='col-sm-3' Align="left">
                                                                                            <label style={{ color: 'black' }}>
                                                                                                <input style={{ marginRight: '1vw' }}
                                                                                                    type="radio"
                                                                                                    value="uploadFileContent"
                                                                                                    checked={this.state.selectedOption === "uploadFileContent"}
                                                                                                    onChange={(event) => this.onChangeRadioButton(event)}
                                                                                                />Upload Audio File</label>
                                                                                        </div>
                                                                                        <div className='col-sm-3' Align="left">
                                                                                            <label style={{ color: 'black' }}>
                                                                                                <input style={{ marginRight: '1vw' }}
                                                                                                    type="radio" Align="left"
                                                                                                    value="uploadURLContent"
                                                                                                    checked={this.state.selectedOption === "uploadURLContent"}
                                                                                                    onChange={(event) => this.onChangeRadioButton(event)}
                                                                                                />Enter Audio URL</label></div>
                                                                                        <div className='col-sm-4'></div>


                                                                                    </div>
                                                                                    <div className='row' style={{ marginTop: '3vw', display: this.state.uploadURLContent ? 'none' : 'block' }}>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Caption</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="audioCaptionId" />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row' style={{ marginTop: '2vw' }}>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Upload Audio</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4' Align="left">
                                                                                                <input id="audioContentId" type="file"
                                                                                                    name="bot-icon-input" Align="left"
                                                                                                    accept="image/x-png,image/gif,image/jpeg"
                                                                                                    // disabled={!this.state.editable}
                                                                                                    onChange={(event) => this.onFileContentChange(event)}
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div></div>

                                                                                    </div>
                                                                                    <div className='row' style={{ marginTop: '3vw', display: this.state.uploadURLContent ? 'block' : 'none' }}>
                                                                                        <div className='row'>
                                                                                            <div className='col-sm-2'></div>

                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Caption</label>
                                                                                            </div>

                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="audioUrlCaptionId" />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div>
                                                                                        </div>
                                                                                        <div className='row' style={{ marginTop: '3vw' }}>
                                                                                            <div className='col-sm-2'></div>
                                                                                            <div className='col-sm-3' Align="left">
                                                                                                <label>Enter Audio URL</label>
                                                                                            </div>
                                                                                            <div className='col-sm-4'>
                                                                                                <input type="text" name="childName" style={{ width: "92%" }}
                                                                                                    className="form-control-plaintext" id="audioContentUrl" Align="left"
                                                                                                />
                                                                                            </div>
                                                                                            <div className='col-sm-3'></div></div>

                                                                                    </div>

                                                                                    <div className='row'>
                                                                                        <div className='col-sm-8'></div>
                                                                                        <div className='col-sm-4' align="right">
                                                                                            <button type="button" style={{ marginTop: '3vw', fontSize: '1rem' }}
                                                                                                className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal"
                                                                                                onClick={(event) => this.state.callFileContentApi ? this.onFileContentUploadApi(event) : this.saveContent(event)}>
                                                                                                Done</button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* ------------- Preview -----------               */}
                                                        <div className="modal" style={{ display: this.state.showpreviewModeOverLay ? 'block' : 'none' }}>
                                                            <div className="modal-dialog" id="center-aligned-account-modal" >
                                                                <div className="modal-content" style={{
                                                                    position: 'absolute', transform: 'translate(7%, -7%)',
                                                                    height: 'auto', width: '35vw', marginTop: '15vh', marginLeft: '15vw'

                                                                }} Align="center">
                                                                    <div className="modal-header noBorder">
                                                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => this.closepreviewModeOverLay()}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                                                <path d="M0 0h24v24H0z" fill="none" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                    <div style={{ width: '100%' }}>
                                                                        {this.state.existingContentInfo.documentSections.map((section, i) => (

                                                                            <div key={i}>
                                                                                <div className='fontpreviewBox' style={{ borderRadius: '1vw', marginTop: '1vw', boxShadow: '0 0 5px 0 #c2c4d2' }}>
                                                                                    <div className={section.caption != null ? 'row' : ''}>
                                                                                        <label style={{ display: section.caption != null ? 'block' : 'none', color: 'rgb(40, 42, 101)', marginTop: '1vw', marginLeft: '2vw', fontWeight: '430', fontSize: '18px' }}>{section.caption}</label>
                                                                                    </div>
                                                                                    <div className='row'>

                                                                                        {this.sectionTemplate(section)}

                                                                                    </div>
                                                                                </div>
                                                                            </div>))}

                                                                        {this.state.existingContentInfo.subFolderList.map((el, i) => (
                                                                            <div key={i}>
                                                                                <div>
                                                                                    <div>

                                                                                        <div className='row' style={{ padding: '1vw', marginLeft: '0.8vw', marginTop: '1vw', marginRight: '-0.2vw' }}>

                                                                                            <div className='col-sm-2' onClick={() => this.onFolderClick(this.state.existingContentInfo.subFolderList[i].id)}>
                                                                                                <div className='previewText image-container' >
                                                                                                    <img id="qr_code" src={"data:png;base64," + this.state.existingContentInfo.subFolderList[i].icon}
                                                                                                        style={{
                                                                                                            width: '9vw', marginLeft: '-1vw',
                                                                                                            height: '8vw', borderRadius: '1vw',
                                                                                                            cursor: 'pointer'
                                                                                                        }} />
                                                                                                </div>
                                                                                            </div>

                                                                                            <div className='col-sm-10'>
                                                                                                <h3 className="m-0 page-title" style={{

                                                                                                    paddingBottom: '1vw', paddingTop: '1vw',
                                                                                                    border: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                                                                                    borderRadius: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '6px' : 'none'
                                                                                                }}>{this.state.existingContentInfo.subFolderList[i].label}</h3>

                                                                                                <div className="textarea"
                                                                                                    // disabled={!this.state.user_editable}
                                                                                                    style={{
                                                                                                        textAlign: 'left',
                                                                                                        height: "auto", resize: 'none', paddingTop: '6px',
                                                                                                        marginTop: '1vw',

                                                                                                        border: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                                                                                        borderRadius: (this.state.existingContentInfo.subFolderList[i].id == "" || this.state.existingContentInfo.subFolderList[i].id == this.state.editedId) ? '6px' : 'none'
                                                                                                    }}
                                                                                                    id={"descriptionId" + [i]}
                                                                                                    contentEditable={!((this.state.existingContentInfo.subFolderList[i].id == "") ? false :
                                                                                                        this.state.existingContentInfo.subFolderList[i].id != this.state.editedId) ? "plaintext-only" : false}
                                                                                                >{this.state.existingContentInfo.subFolderList[i].description}</div>
                                                                                            </div>

                                                                                            <br />
                                                                                        </div>
                                                                                        <br />
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        ))}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Dialog Component For Deletion Confirmation*/}
                    {/* <DialogComponent width='400px' animationSettings={this.settings}
                        header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog} target='#contentLibForServiceLineTab'
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;&nbsp;&nbsp;&nbsp;Do you want to delete?<br />
                        Note: Press 'Yes' to delete or press 'No' to decline.
                    </DialogComponent> */}
                </div >
            </div >

        );
    }
}


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ContentLibraryForServiceLine.js